import styled from "styled-components";

const SidebarSubMenu = styled.ul`
  padding: 0;
  list-style-type: none;
`;

export default SidebarSubMenu;
